import { SimpleSortBy } from "../tables/ISimpleTable";

export interface IDirectionalToggle {
    direction: Direction;
    sortAscending: any;
    sortDescending: any;
    text?: string 
    defaultSort?: SimpleSortBy
    onRemoveDefaultSort?:any,
    ascendingLabel?: string,
    descendingLabel?: string
}

export enum Direction {
    UP = "UP", DOWN = "DOWN", BOTH="BOTH"
}